/* eslint-disable */

import * as THREE from 'three'
import ParticlesShader from './Shaders/Particles.js'

class Particles
{
    /**
     * Constructor
     */
    constructor(options = {})
    {
        // Options
        this.time = options.time
        this.count = typeof options.count !== 'undefined' ? options.count : 1200

        // Container
        this.container = new THREE.Object3D()

        // Attributes
        this.attributes = {}
        this.attributes.positions = new Float32Array(this.count * 3)

        let i = 0

        while(i < this.count)
        {
            const position = this.getRandomSpherePoint(0, 0, 0, 1.15)
            position[ 0 ] += Math.random() * 0.05
            position[ 1 ] += Math.random() * 0.05
            position[ 2 ] += Math.random() * 0.05

            this.attributes.positions[i * 3 + 0] = position[0]
            this.attributes.positions[i * 3 + 1] = position[1]
            this.attributes.positions[i * 3 + 2] = position[2]

            i++
        }

        // Uniforms
        this.uniforms = {
            uRandomSeed: { value: Math.random() },
            uTime: { value: 0 },
            uAlpha: { value: 1.25 },
            uSize: { value: 0.005 },
            uSmoothness: { value: 0.3 },
            uColor: { value: new THREE.Color(0xaa5555) },
            uPositionPerlinLarge: { value: new THREE.Vector3(1, 2, 0) }, // Frequency / Speed / Strength
            uPositionPerlinMedium: { value: new THREE.Vector3(6, 1, 0.2) }, // Frequency / Speed / Strength
            uBlur: { value: new THREE.Vector3(0.002, 5.0, 1.5) }, // Distance / Size strength / Smoothness strength
        }

        // Material
        this.material = new THREE.ShaderMaterial({
            uniforms: this.uniforms,
            vertexShader: ParticlesShader.vertexShader,
            fragmentShader: ParticlesShader.fragmentShader,
            // blending: THREE.AdditiveBlending,
            depthTest: false,
            transparent: true
        })

        // Geometry
        this.geometry = new THREE.BufferGeometry()
        this.geometry.addAttribute('position', new THREE.BufferAttribute(this.attributes.positions, 3))

        // Points
        this.points = new THREE.Points(this.geometry, this.material)

        // Add
        this.container.add(this.points)
    }

    /**
     * Get random sphere point
     */
    getRandomSpherePoint(x0, y0, z0, radius)
    {
        let u = Math.random()
        let v = Math.random()
        let theta = 2 * Math.PI * u
        let phi = Math.acos(2 * v - 1)
        let x = x0 + (radius * Math.sin(phi) * Math.cos(theta))
        let y = y0 + (radius * Math.sin(phi) * Math.sin(theta))
        let z = z0 + (radius * Math.cos(phi))

        return [ x, y, z ]
    }

    /**
     * Update
     */
    update()
    {
        this.uniforms.uTime.value = this.time.current
    }
}

export default Particles



// WEBPACK FOOTER //
// ./src/scripts/components/page-home/Background/Particles.js